export default __webpack_public_path__ + "static/media/toluwanimi_ayoola.a2d2212d.jpg";